export default __webpack_public_path__ + "static/04-30d3d4db3864dfb373dbb4ded864722f.jpg";